import { useState, useEffect } from "react";
import EventProductsModal from "../EventProductsModal";
import { useParams } from "react-router-dom";
import apiClient from '../../../../services/apiClient';
import Swal from "sweetalert2";
function EventProducts() {
  const [showAddCategory, setShowAddCategory] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState([]); // [{key, type}]
  const [items, setItems] = useState({});
  const { eventid } = useParams();

  const [showModal, setShowModal] = useState(false);
  const [modalCategory, setModalCategory] = useState(null);

  // Fetch products/packages for this event
  useEffect(() => {
    const fetchEventProducts = async () => {
      try {
        const response = await apiClient.get(
          `/event-products/${eventid}`
        );

        const data = response.data; // array of items from backend
        const grouped = {};
        const categories = [];

        data.forEach((item) => {
          const key = item.tab_key || `${item.type}-${Date.now()}`;
          if (!grouped[key]) grouped[key] = [];
          grouped[key].push(item);

          if (!categories.find((c) => c.key === key)) {
            categories.push({ key, type: item.type });
          }
        });

        setItems(grouped);
        setSelectedCategory(categories);
      } catch (err) {
        console.error("Error fetching event products:", err);
      }
    };

    fetchEventProducts();
  }, [eventid]);

  // Add item (save one by one)
  // Add item (save one by one)
  const handleItemAddFromModal = async (item) => {

    if (!modalCategory) return;

    try {
      const response = await apiClient.post(
        `/event-products/add`,
        {
          event_id: eventid,
          item_id: item.id, // product/package id
          type: modalCategory.type,
          tab_key: modalCategory.key,
        }
      );

      // normalize backend response
      const savedItem = {
        ...response.data,
        image:
          response.data.image ||
          response.data.image1 ||
          response.data.image2 ||
          response.data.image3 ||
          null,
      };

      const updated = {
        ...items,
        [modalCategory.key]: [...(items[modalCategory.key] || []), savedItem],
      };

      setItems(updated);
      setShowModal(false);
    } catch (err) {
      console.error("Error adding item:", err);
    }
  };

  // Delete one item
  const handleDelete = async (catKey, id) => {
    const confirmation = await Swal.fire({
      title: "Are you sure?",
      text: "You want to delete this item. You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    });

    if (confirmation.isConfirmed) {
      try {
        await apiClient.delete(
          `/event-products/${id}`
        );

        const updated = {
          ...items,
          [catKey]: (items[catKey] || []).filter((item) => item.id !== id),
        };

        setItems(updated);

        Swal.fire("Deleted!", "Item has been deleted.", "success");
      } catch (err) {
        console.error("Error deleting item:", err);
        Swal.fire("Error!", "Something went wrong.", "error");
      }
    }
  };

  // Delete entire tab
  const handleDeleteCategory = async (catKey) => {
    const confirmation = await Swal.fire({
      title: "Are you sure?",
      text: "You want to delete this entire tab. You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    });

    if (confirmation.isConfirmed) {
      try {
        await apiClient.delete(
          `/event-products/tab/${eventid}/${catKey}`
        );

        const updatedCategories = selectedCategory.filter(
          (c) => c.key !== catKey
        );
        setSelectedCategory(updatedCategories);

        const updated = { ...items };
        delete updated[catKey];
        setItems(updated);

        Swal.fire("Deleted!", "Tab has been deleted.", "success");
      } catch (err) {
        console.error("Error deleting tab:", err);
        Swal.fire("Error!", "Something went wrong.", "error");
      }
    }
  };

  // Add new category (tab)
  const handleCategorySelect = (type) => {
    if (!type) return;

    const newKey = `${type}-${Date.now()}`;
    setSelectedCategory([...selectedCategory, { key: newKey, type }]);
    setItems((prev) => ({
      ...prev,
      [newKey]: [],
    }));

    setShowAddCategory(false);
  };

  return (
    <>
      <div className="container-fluid back_color mb-5">
        <div className="row bg-white p-3">
          <div className="col-sm-12">
            <h4>Products & Packages for Event</h4>
            <p>
              Choose the Products or Packages approved for this Event <br />
              Select items below or add more if needed
            </p>
          </div>
        </div>

        {/* Render tabs (categories) */}
        {selectedCategory.map(({ key, type }) => (
          <div className="mt-4 bg-white p-3" key={key}>
            <div className="row">
              <div className="col-sm-6">
                <h4>{type}</h4>
              </div>
              <div className="col-sm-6 d-flex justify-content-end mt-2">
                <div className="dropdown">
                  <i
                    className="fas fa-ellipsis-h fa-xl icon_size"
                    role="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                    style={{ cursor: "pointer" }}
                  ></i>
                  <ul className="dropdown-menu">
                    <li>
                      <button
                        className="dropdown-item text-danger"
                        onClick={() => handleDeleteCategory(key)}
                      >
                        Delete {type} Tab
                      </button>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-sm-10">
                <div className="row g-lg-3 g-sm-3 g-2 mt-1">
                  {(items[key] || []).map((item) => (
                    <div
                      className="col-md-4 col-sm-4 col-12"
                      key={`${item.type}-${item.id}`}
                    >
                      <div className="upload-btn-wrapper p-0 position-relative">
                        {item.image ? (
                          <img
                            src={
                              `${process.env.REACT_APP_BACKEND_URL}/` +
                              item.image
                            }
                            className="img-fluid"
                            alt={item.name}
                          />
                        ) : (
                          <img
                            src="/img/photo-gallery.png"
                            className="img-fluid"
                            alt="placeholder"
                          />
                        )}
                        <span>{item.name}</span>

                        {/* Delete one item */}
                        <button
                          className="btn btn-sm btn-danger position-absolute"
                          style={{
                            top: "5px",
                            right: "5px",
                            borderRadius: "50%",
                          }}
                          onClick={() => handleDelete(key, item.id)}
                        >
                          <i className="fas fa-times"></i>
                        </button>
                      </div>
                    </div>
                  ))}

                  {/* Add new item → opens modal */}
                  <div className="col-md-4 col-sm-4 col-12">
                    <div
                      className="upload-btn-wrapper p-0"
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        setModalCategory({ key, type });
                        setShowModal(true);
                      }}
                    >
                      <img
                        src="/img/photo-gallery.png"
                        className="img-fluid"
                        alt="add"
                      />
                      <span>Select {type}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}

        {/* Add new category (tab) */}
        <div className="row mt-5">
          {!showAddCategory ? (
            <div
              className="d-flex align-items-center"
              onClick={() => setShowAddCategory(true)}
            >
              <button
                type="button"
                className="btn btn-primary d-flex align-items-center justify-content-center rounded-circle me-2"
                style={{ width: "40px", height: "40px" }}
              >
                +
              </button>
              <p className="mb-0">Add Item Category</p>
            </div>
          ) : (
            <div className="col-md-4 mb-5">
              <label className="form-label">Item Category</label>
              <select
                onChange={(e) => handleCategorySelect(e.target.value)}
                className="form-select"
                style={{ height: "60px", borderRadius: "10px" }}
              >
                <option value="">Select an option</option>
                <option value="Products">Products</option>
                <option value="Packages">Packages</option>
              </select>
            </div>
          )}
        </div>
      </div>

      {/* Modal */}
      {showModal && modalCategory && (
        <EventProductsModal
          eventid={eventid}
          type={modalCategory.type}
          onSelect={handleItemAddFromModal}
          onClose={() => setShowModal(false)}
        />
      )}
    </>
  );
}

export { EventProducts };
